"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.IconWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _sharedStyle = require("../../styles/sharedStyle"); // eslint-disable-next-line import/prefer-default-export


var IconWrapper = (0, _styled.default)('span')(function (_ref) {
  var spaceAround = _ref.spaceAround;
  return spaceAround ? _styledSystem.space : {
    margin: 0
  };
}, _styledSystem.color, _styledSystem.width, _styledSystem.minWidth, _styledSystem.height, _styledSystem.display, _styledSystem.verticalAlign, _sharedStyle.transform, {
  pointerEvents: 'none'
});
exports.IconWrapper = IconWrapper;
IconWrapper.defaultProps = {
  display: 'inline-block',
  position: 'relative',
  verticalAlign: 'middle'
};